import { itemServices } from 'src/services/reservation/item/item.service'
import { customAwait } from 'src/components/pages/sales/reservation/helper/customAwait'
type Refresh = () => void

interface CancelTrainSegmentReservationParams {
  hashItemReserve: string
  nameReserve: string
  refresh: Refresh
  notify: any
  setLoadingCancelItem: React.Dispatch<React.SetStateAction<boolean>>
  setNameReserve: React.Dispatch<React.SetStateAction<string>>
  setHashItemReserve: React.Dispatch<React.SetStateAction<string>>
  setConfirm: React.Dispatch<React.SetStateAction<boolean>> | undefined
  setOpen: React.Dispatch<React.SetStateAction<boolean>> | undefined
}

export const cancelTrainSegmentReservation = async ({
  hashItemReserve,
  nameReserve,
  refresh,
  notify,
  setLoadingCancelItem,
  setNameReserve,
  setHashItemReserve,
  setConfirm,
  setOpen,
}: CancelTrainSegmentReservationParams): Promise<void> => {
  try {
    setLoadingCancelItem(true)
    setOpen && setOpen(false)
    const response = await itemServices.refund_train_segment(hashItemReserve)
    if (response === 200) {
      notify('ra.notification.canceled_item_reserve_success', {
        type: 'success',
        messageArgs: { reserve: nameReserve },
      })
      setNameReserve('')
      setHashItemReserve('')
      setConfirm && setConfirm(false)
      setLoadingCancelItem(false)
      return
    }
    setNameReserve('')
    setHashItemReserve('')
    setConfirm && setConfirm(false)
    setLoadingCancelItem(false)
    notify('ra.notification.canceled_item_reserve_error', {
      type: 'error',
      messageArgs: { reserve: nameReserve },
    })
  } catch (error) {
    notify('ra.notification.canceled_item_reserve_error', {
      type: 'error',
      messageArgs: { reserve: nameReserve },
    })
    setNameReserve('')
    setHashItemReserve('')
    setLoadingCancelItem(false)
    setConfirm && setConfirm(false)
    setOpen && setOpen(false)
  } finally {
    customAwait([refresh])
  }
}
